import {
  REFERENCE_DATA_TEMPLATES_OBJECT_TYPE,
  type IReferenceDataTemplatesApi,
  type TReferenceDataTemplatesCreateResult,
  type TReferenceDataTemplatesData,
  type TReferenceDataTemplatesObject,
} from '@repo/reference-wells';

import { goStorageAgent } from 'src/api/goStorageAgent';
import { throwApiError } from 'src/api/utils';

const objectPath = `object/list/${REFERENCE_DATA_TEMPLATES_OBJECT_TYPE}`;
const objectNewPath = `object/new/${REFERENCE_DATA_TEMPLATES_OBJECT_TYPE}`;

export class ReferenceDataTemplatesApi implements IReferenceDataTemplatesApi {
  async listPublic(wellId: number): Promise<TReferenceDataTemplatesObject[]> {
    try {
      const { data } = await goStorageAgent.get<TReferenceDataTemplatesObject[]>(objectPath, {
        params: {
          type: 'public',
          wellId,
        },
      });

      return data;
    } catch (error) {
      throwApiError(error);
    }
  }

  async listPersonal(wellId: number, ownerUserId: string): Promise<TReferenceDataTemplatesObject[]> {
    try {
      const { data } = await goStorageAgent.get<TReferenceDataTemplatesObject[]>(objectPath, {
        params: {
          type: 'personal',
          wellId,
          ownerUserId,
        },
      });

      return data;
    } catch (error) {
      throwApiError(error);
    }
  }

  async create(data: TReferenceDataTemplatesData): Promise<TReferenceDataTemplatesCreateResult> {
    try {
      const { data: created } = await goStorageAgent.post<TReferenceDataTemplatesCreateResult>(objectNewPath, data);

      return created;
    } catch (error) {
      throwApiError(error);
    }
  }

  async update(id: number, data: TReferenceDataTemplatesData): Promise<void> {
    try {
      await goStorageAgent.patch(`object/${REFERENCE_DATA_TEMPLATES_OBJECT_TYPE}/${id}`, data);
    } catch (error) {
      throwApiError(error);
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await goStorageAgent.delete(`object/${REFERENCE_DATA_TEMPLATES_OBJECT_TYPE}/${id}`);
    } catch (error) {
      throwApiError(error);
    }
  }
}
